import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EmailIcon from '@material-ui/icons/Email';

import User from '../../../../types/User';
import AuditorFooter from '../AuditorFooter/AuditorFooter';
import CertifierFooter from '../CertifierFooter/CertifierFooter';
import CustomerFooter from '../CustomerFooter/CustomerFooter';
import { StyledList, StyledListItem } from './styled';

/*
 * Footer of the company details dialog;
 * it includes the button for see and modify the users, auditors, locations and certificates.
 */

interface Props {
    user: User;
    updateData: () => void;
    saveIfNeeded: () => Promise<void>;
    isLoading?: boolean;
}

const Footer = (props: Props) => {
    const { user, updateData, saveIfNeeded, isLoading } = props;
    const { t } = useTranslation();

    const flags = {
        false: t('dialogs.user_details.flag_no'),
        true: t('dialogs.user_details.flag_yes')
    };

    return (
        <>
            <StyledList>
                { /* @ts-ignore https://github.com/mui-org/material-ui/issues/14971 */}
                <StyledListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <AccountCircleIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={(
                        <Trans i18nKey='dialogs.user_details.privacy_consent' tOptions={{ flag: flags[user.privacy ? 'true' : 'false'] }} >
                            _<strong></strong>_
                        </Trans>
                    )} />
                </StyledListItem>

                { /* @ts-ignore https://github.com/mui-org/material-ui/issues/14971 */}
                <StyledListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <EmailIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={(
                        <Trans i18nKey='dialogs.user_details.newsletter' tOptions={{ flag: flags[user.newsletter ? 'true' : 'false'] }} >
                            _<strong></strong>_
                        </Trans>
                    )} />
                </StyledListItem>
            </StyledList>

            {user.type === 'auditor' && (
                <AuditorFooter user={user} updateData={updateData} saveIfNeeded={saveIfNeeded} isLoading={isLoading} />
            )}

            {user.type === 'certifier' && (
                <CertifierFooter user={user} updateData={updateData} saveIfNeeded={saveIfNeeded} isLoading={isLoading} />
            )}

            {user.type === 'customer' && (
                <CustomerFooter user={user} updateData={updateData} saveIfNeeded={saveIfNeeded} isLoading={isLoading} />
            )}
        </>
    );
};

export default Footer;
